import { Box } from '@mui/material'
import React from 'react'
import styles from './CuratedList.module.scss'

function CuratedImage({ src = '/images/CuratedList.jpg', alt = 'Curated Image', index = 0 }) {
  return (
    <Box className={styles.CuratedImage}>
      <img
        src={src}
        alt={alt}
        loading={index < 3 ? 'eager' : 'lazy'}
        decoding="async"
        fetchPriority={index < 2 ? 'high' : 'auto'}
      />
    </Box>
  )
}

export default React.memo(CuratedImage)
